$( document ).ready(function() {
  // $(".hamburger").click(function () {
  //     $(this).toggleClass("is-active");
  //     $('body').toggleClass("is-active");
  //     $('.header__mobilelargemenu').toggleClass("is-active");
  //     $('.nav ul').toggleClass("is-active");
  // });

  $('body').on('click', '#recover-click', function (e) {
    $('#recover-modal').show();
    $('#login-modal').hide();
  });

  $('body').on('click', '#login-click', function (e) {
    $('#recover-modal').hide();
    $('#login-modal').show();
  });


  $('body').on('click', '.rc_widget__option--subsave', function (e) {
    $(".product-detail__amount").addClass("subscription");
    $(".product-detail__price").addClass("subscription");
    $(".product-detail__price-holder-right").show();
  });

  $('body').on('click', '.rc_widget__option__input--onetime', function (e) {
    $(".product-detail__amount").removeClass("subscription");
    $(".product-detail__price").removeClass("subscription");
    $(".product-detail__price-holder-right").hide();
  });


  $('.product-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.product-slider-nav',
    focusOnSelect: true,
    infinite: true,
  });

  if (window.matchMedia("(max-width: 992px)").matches) {
    $('.header__kf-logos').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      arrows: false,
      dots: false,
      autoplaySpeed: 2000,
      centerMode: false,
    });
    $('.cart-page__knownform-logos').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      arrows: false,
      dots: false,
      autoplaySpeed: 2000,
      centerMode: false,
    });
    $('.content-c__knowfrom-logos').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      arrows: false,
      dots: false,
      autoplaySpeed: 2000,
      centerMode: false,
    });

    $('.partners__right').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      arrows: false,
      dots: false,
      autoplaySpeed: 2000,
      centerMode: true,
    });


    // $('.cart-page__knownform-logos').slick({
    //   slidesToShow: 2,
    //   slidesToScroll: 1,
    //   infinite: true,
    //   autoplay: true,
    //   arrows: false,
    //   dots: false,
    //   autoplaySpeed: 2000,
    //   centerMode: true,
    // });


    // $('.cart-page__knownform-logos').slick({
    //   slidesToShow: 3,
    //   slidesToScroll: 1,
    //   infinite: true,
    //   autoplay: true,
    //   arrows: false,
    //   dots: false,
    //   autoplaySpeed: 2000,
    //   centerMode: true,
    // });


    // $('.partners__right').slick({
    //   slidesToShow: 2,
    //   slidesToScroll: 1,
    //   infinite: true,
    //   autoplay: true,
    //   arrows: false,
    //   dots: false,
    //   autoplaySpeed: 2000,
    //   // centerMode: true,
    // });
  } 

  $('.product-slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.product-slider',
    arrows: true,
    infinite: true,
    arrows: true,
    focusOnSelect: true,
    centerMode: true,
    //infinite: true,
    variableWidth: true,

    responsive: [
        {
          breakpoint: 320,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        }
    ]
  });

  if($('input[data-cups="Subscription"]').is(':checked')) {
    $('.product-detail__alert').show();
    $('.product-detail__amount-cups-selection').show();
    // $('.product-detail__sub-price').show();
    $('.product-detail__onetime-price').hide();
    $(".product-detail__price-holder-right").show();
    $(".product-detail__amount span").show();
  };

  if($('input[data-cups="One-time"]').is(':checked')) {
    $(".product-detail__price-holder-right").hide();
  };

  $('body').on('click', 'input[data-cups="Subscription"]', function (e) {
      $('.product-detail__alert').show();
      $('.product-detail__amount-cups-selection').show();
      // $('.product-detail__sub-price').show();
      $('.product-detail__onetime-price').hide();
      $(".product-detail__price-holder-right").show();
      $(".product-detail__amount span").show();
  });

  $('body').on('click', 'input[data-cups="One-time"]', function (e) {
      $('.product-detail__alert').hide();
      $('.product-detail__amount-cups-selection').hide();
      // $('.product-detail__sub-price').hide();
      $('.product-detail__onetime-price').show();
      $(".product-detail__price-holder-right").hide();
      $(".product-detail__amount span").hide();
  });




  var AmountCups = $(".product-form__input-aantal .product-detail__price-holder input").attr("data-cups");
  var DividedAmountCups = Math.floor(AmountCups / 30);
  $(".product-detail__amount-cups").text(DividedAmountCups);

  $('body').on('click', '.product-form__input-aantal .product-detail__price-holder input', function (e) {
    var AmountCups = $(this).attr("data-cups");
    var DividedAmountCups = Math.floor(AmountCups / 30);
    $(".product-detail__amount-cups").text(DividedAmountCups);
  });



  // $('body').on('click', '.tabs__item-header', function (e) {
  //   e.preventDefault();
  //   var item = this;

  //   if ($(item).parent().hasClass("active")) {
  //     $(item).parent().removeClass('active');
  //     $(item).parent().find('.tabs__item-content').slideUp();
  //   // } else {
  //     $('.tabs__item-content').slideUp();
  //     $('.tabs__item').removeClass('active');
  //     $(item).parent().addClass('active');
  //     $(item).parent().find('.tabs__item-content').slideDown();
  //   }
  // });


$(document).ready(function() {
  // Ensure all tabs are closed by default
  $('.tabs__item').removeClass('active'); // Remove active class from all tabs
  $('.tabs__item-content').slideUp(); // Hide all tab content

  // Handle tab click to toggle open/closed state
  $('body').on('click', '.tabs__item-header', function (e) {
    e.preventDefault();
    var item = this;

    if ($(item).parent().hasClass("active")) {
      $(item).parent().removeClass('active');
      $(item).parent().find('.tabs__item-content').slideUp();
    } else {
      $('.tabs__item-content').slideUp(); // Close all other tab content
      $('.tabs__item').removeClass('active'); // Remove active class from all tabs
      $(item).parent().addClass('active'); // Add active class to clicked tab
      $(item).parent().find('.tabs__item-content').slideDown(); // Open the clicked tab content
    }
  });
});





  // $('.tabgroup > div').hide();
  // $('.tabgroup > div:first-of-type').show();

  $('.product-detail__selection-tab-itemname').click(function(e){
    e.preventDefault();
    console.log('test');
    $('.product-detail__selection-tab-itemname').removeClass('active');
    $(this).addClass('active');
  })   

  $('.crs').slick({
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    fade: true,
    cssEase: 'linear',
    adaptiveHeight: true,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<div class="header-slider__items-arrow header-slider__items-arrow--prev"><svg width="16" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.827.242a.719.719 0 0 1 .802-.192.83.83 0 0 1 .432.192 49.911 49.911 0 0 1 3.146 2.876c.433.432.219 1.001-.181 1.252-2.108 2.508-4.515 4.991-6.62 7.501 2.388 2.4 4.69 5.117 6.98 7.605.258.28.268.608.144.877-.02.256-.174.49-.397.663a50.513 50.513 0 0 0-3.042 2.553c-.247.405-.824.629-1.264.196C7.32 20.317 4.25 16.431.402 13.34a.76.76 0 0 1-.221-.274c-.22-.29-.276-.708.041-1.05C3.811 8.14 7.147 4.036 10.827.242Z" fill="#EBEBEB"/></svg></div>',
    nextArrow: '<div class="header-slider__items-arrow"><svg width="16" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.173.242A.719.719 0 0 0 4.371.05a.83.83 0 0 0-.432.192A49.88 49.88 0 0 0 .793 3.118C.36 3.55.574 4.12.974 4.37 3.082 6.878 5.49 9.36 7.594 11.87c-2.388 2.4-4.69 5.117-6.98 7.605a.773.773 0 0 0-.144.877c.02.256.174.49.397.663a50.516 50.516 0 0 1 3.042 2.553c.247.405.824.629 1.264.196 3.507-3.448 6.577-7.334 10.425-10.425a.759.759 0 0 0 .221-.274c.22-.29.276-.708-.041-1.05C12.189 8.14 8.853 4.036 5.173.242Z" fill="#EBEBEB"/></svg></div>',
  });

  $('.header-slider__items').slick({
      dots: false,
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      adaptiveHeight: true,
      fade: true,
      cssEase: 'linear',
      slidesToScroll: 1,
      arrows: true,
      prevArrow: '<div class="header-slider__items-arrow header-slider__items-arrow--prev"><svg width="16" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.827.242a.719.719 0 0 1 .802-.192.83.83 0 0 1 .432.192 49.911 49.911 0 0 1 3.146 2.876c.433.432.219 1.001-.181 1.252-2.108 2.508-4.515 4.991-6.62 7.501 2.388 2.4 4.69 5.117 6.98 7.605.258.28.268.608.144.877-.02.256-.174.49-.397.663a50.513 50.513 0 0 0-3.042 2.553c-.247.405-.824.629-1.264.196C7.32 20.317 4.25 16.431.402 13.34a.76.76 0 0 1-.221-.274c-.22-.29-.276-.708.041-1.05C3.811 8.14 7.147 4.036 10.827.242Z" fill="#EBEBEB"/></svg></div>',
      nextArrow: '<div class="header-slider__items-arrow"><svg width="16" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.173.242A.719.719 0 0 0 4.371.05a.83.83 0 0 0-.432.192A49.88 49.88 0 0 0 .793 3.118C.36 3.55.574 4.12.974 4.37 3.082 6.878 5.49 9.36 7.594 11.87c-2.388 2.4-4.69 5.117-6.98 7.605a.773.773 0 0 0-.144.877c.02.256.174.49.397.663a50.516 50.516 0 0 1 3.042 2.553c.247.405.824.629 1.264.196 3.507-3.448 6.577-7.334 10.425-10.425a.759.759 0 0 0 .221-.274c.22-.29.276-.708-.041-1.05C12.189 8.14 8.853 4.036 5.173.242Z" fill="#EBEBEB"/></svg></div>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
  });

  $('.product-slider__items').slick({
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<div class="product-slider__arrow product-slider__arrow--prev"><svg width="16" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.827.242A.719.719 0 0 1 11.63.05a.83.83 0 0 1 .432.192 49.882 49.882 0 0 1 3.146 2.876c.434.432.219 1.001-.18 1.252-2.109 2.508-4.515 4.991-6.62 7.501 2.387 2.4 4.689 5.117 6.98 7.605.257.28.267.608.144.877-.02.256-.175.49-.398.663a50.513 50.513 0 0 0-3.042 2.553c-.247.405-.824.629-1.263.196C7.32 20.317 4.25 16.431.402 13.34a.76.76 0 0 1-.22-.274c-.221-.29-.277-.708.04-1.05C3.813 8.14 7.148 4.036 10.828.242Z" fill="#EBEBEB"/></svg></div>',
    nextArrow: '<div class="product-slider__arrow product-slider__arrow--next"><svg width="16" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.173.242A.719.719 0 0 0 4.37.05a.83.83 0 0 0-.432.192A49.878 49.878 0 0 0 .793 3.118C.359 3.55.574 4.12.973 4.37 3.083 6.878 5.49 9.36 7.594 11.87c-2.387 2.4-4.689 5.117-6.98 7.605a.773.773 0 0 0-.144.877c.02.256.175.49.398.663a50.515 50.515 0 0 1 3.042 2.553c.247.405.824.629 1.263.196 3.507-3.448 6.578-7.334 10.426-10.425a.76.76 0 0 0 .22-.274c.221-.29.277-.708-.04-1.05C12.188 8.14 8.852 4.036 5.172.242Z" fill="#EBEBEB"/></svg></div>',
  });


 $('.top-bar').slick({
      dots: false,
      infinite: true,
      speed: 600,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 4000,
  });

// Select all links with hashes
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });

});


$(".hamburger").click(function () {
  $("html").toggleClass("is-active");
  $("body").toggleClass("is-active");
  $(this).toggleClass("is-active");
  $(".nav__mobile-menu").toggleClass("is-active");
  $(".nav__moverlay").toggleClass("is-active");
});


$(window).scroll(function () {
  var scroll = $(window).scrollTop();
  if (scroll >= 5) {
      $(".nav__holder").addClass("is-sticky")
  } else {
      $(".nav__holder").removeClass("is-sticky")
  }
});